import React from "react";
import { bind } from "decko";
import throttle from "lodash.throttle";
import $ from "jquery";

export default class StreamTimeline extends React.Component {
    constructor (props) {
        super(props);

        this.onSeek = this.onSeek.bind(this);
        // Adding a throttled version of the seek function as well
        // Improves performance and user experience when dragging (touch)
        this.onSeekThrottled = throttle(this.onSeek.bind(this), 150);

        this.currentPlaybackRate = 1;
    }

    onSeek (pageX) {
        const pixelPosition = pageX - this.timelineElement.getBoundingClientRect().left;
        const percentage = Math.min(1, Math.max(0, (pixelPosition / this.timelineElement.offsetWidth)));
        const time = this.props.expectedDuration * percentage;

        console.log('Seeking to: ' + time);
        this.props.onSeek(time);

        return time;
    }

    @bind
    onMouseMove (ev) {
        if (this.mouseDownElement) {
            if (this.mouseDownElement === "timeline") {
                this.onSeekThrottled(ev.pageX);
            } else {
                this.props.onMoveMarker(this.mouseDownElement, this.onSeekThrottled(ev.pageX));
            }
        }
    }

    @bind
    onMouseDown (ev, marker) {
        ev.preventDefault();
        ev.stopPropagation();
        this.mouseDownElement = marker;
        this.currentPlaybackRate = this.props.video.playbackRate;
        const self = this;
        // TODO Get rid of Jquery...
        $(window).on("mousemove", this.onMouseMove);
        $(window).one("mouseup", function () {
            $(window).off("mousemove", self.onMouseMove);
            self.mouseDownElement = undefined;
            self.props.video.playbackRate = self.currentPlaybackRate;
        });
    }

    @bind
    onTouchStart (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.currentPlaybackRate = this.props.video.playbackRate;
        this.props.video.playbackRate = 0;
    }

    @bind
    onTouchEnd (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.video.playbackRate = this.currentPlaybackRate;
    }

    @bind
    onTouchMove (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.onSeekThrottled(ev.touches[0].pageX);
    }

    moveMarker (ev, marker) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.onMoveMarker(marker, this.onSeekThrottled(ev.touches[0].pageX));
    }

    timeToStylePos (time) {
        return "" + Math.min(100, 100 * time / this.props.expectedDuration) + "%";
    }

    render () {

        const buffers = this.props.bufferRanges.map((buffer) => (
            <div key={buffer.start} className="timeline-buffer" style={{
                left: this.timeToStylePos(buffer.start),
                width: this.timeToStylePos(buffer.end - buffer.start),
            }} />
        ));

        let missingStreamRegion = null;
        let missingStreamData = this.props.expectedDuration - this.props.duration;
        if (missingStreamData > 0) {
            missingStreamRegion = (
                <div className="timeline-not-ready" style={{
                    width: this.timeToStylePos(missingStreamData)
                }} />
            );
        }

        return (
            <div className="stream-timeline"
                onContextMenu={(ev) => ev.preventDefault()}
                onClick={(ev) => this.onSeek(ev.pageX)}
                onTouchStart={this.onTouchStart}
                onTouchEnd={this.onTouchEnd}
                onTouchMove={this.onTouchMove}
                onMouseDown={(ev) => this.onMouseDown(ev, "timeline")}
                ref={(timeline) => this.timelineElement = timeline}>
                { buffers }
                { missingStreamRegion }
                <div className="timeline-progress" style={{width: this.timeToStylePos(this.props.progress)}} />
                <div className="timeline-background" />
                <div className="timeline-marker"
                    onMouseDown={(ev) => this.onMouseDown(ev, "start")}
                    onTouchMove={(ev) => this.moveMarker(ev, "start")}
                    style={{left: this.timeToStylePos(this.props.start)}}>
                    <div style={{backgroundColor: "darkgreen"}} />
                </div>
                <div className="timeline-marker"
                    onMouseDown={(ev) => this.onMouseDown(ev, "event")}
                    onTouchMove={(ev) => this.moveMarker(ev, "event")}
                    style={{left: this.timeToStylePos(this.props.event)}}>
                    <div style={{backgroundColor: "orange"}} />
                </div>
                <div className="timeline-marker"
                    onMouseDown={(ev) => this.onMouseDown(ev, "end")}
                    onTouchMove={(ev) => this.moveMarker(ev, "end")}
                    style={{left: this.timeToStylePos(this.props.end)}}>
                    <div style={{backgroundColor: "darkred"}} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/StreamTimeline.js